import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "UiCard__in" }
const _hoisted_2 = {
  key: 0,
  class: "UiCard__header"
}
const _hoisted_3 = {
  key: 1,
  class: "UiCard__content"
}
const _hoisted_4 = {
  key: 2,
  class: "UiCard__footer"
}

import "./UiCard.css";

import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'UiCard',
  props: {
  dense: { type: Boolean, default: false },
},
  setup(__props) {

const props = __props



const rootClasses = computed(() => ({
  UiCard: true,
  "UiCard--dense": props.dense,
}));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(rootClasses))
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.$slots.header)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _renderSlot(_ctx.$slots, "header")
          ]))
        : _createCommentVNode("", true),
      (_ctx.$slots.default)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _renderSlot(_ctx.$slots, "default")
          ]))
        : _createCommentVNode("", true),
      (_ctx.$slots.footer)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _renderSlot(_ctx.$slots, "footer")
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})